var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"drawCard"},[_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/lottery.gif","alt":""}}),_c('div',{staticClass:"close",on:{"click":_vm.changeShow}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }